import React, { Component } from 'react';

import Vimeo from '@vimeo/player';
import PropTypes from 'prop-types';

class VimeoPlayer extends Component {
  componentDidMount() {
    this.vimeoPlayer = new Vimeo('vimeo-player', {
      url: this.props.vimeoLink,
      autoplay: true
    });
    this.vimeoPlayer.ready().then(() => this.videoOnLoad());
  }

  async componentDidUpdate(prevProps) {
    try {
      if (prevProps.vimeoLink !== this.props.vimeoLink) {
        clearInterval(this.timer);
        await this.vimeoPlayer.unload();
        await this.vimeoPlayer.loadVideo({
          url: this.props.vimeoLink
        });
        this.vimeoPlayer.ready().then(() => this.videoOnLoad());
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  componentWillUnmount() {
    if (this.vimeoPlayer) {
      this.vimeoPlayer.destroy();
    }
  }

  videoOnLoad = () => {
    this.vimeoPlayer.on('ended', () => {
      this.props.onVideoComplete();
    });
  };

  render() {
    return (
      <div
        className="vimeoPlayer-container"
        id="vimeo-player" />
    );
  }
}

VimeoPlayer.defaultProps = {
  onVideoComplete: () => { }
};

VimeoPlayer.propTypes = {
  data: PropTypes.object.isRequired,
  onVideoComplete: PropTypes.func
};

export default VimeoPlayer;
